import React from 'react';
import { Route } from 'react-router-dom';
import UserShoppingCart from './userShoppingCart';

export default <Route path="/homepage/carrinho" component={UserShoppingCart} />;
